angular.module('impactx.opengovernmentdata').controller('OpenGovernmentDataEditDialogCtrl', [
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    OpenGovernmentDataEditDialogController
]);

function OpenGovernmentDataEditDialogController(dataGen, $mdDialog, ToastService, TranslationService) {
    var self = this;
    self.showAll = false;
    self.minDateNow = new Date();

    if (self.prsId) {
        self.cpvCodeInputEntryPoint = '/opengovernmentdata/report/cpvcodes/request';
        self.cpvCodeInputObjectId = self.prsId;
    }
    else if (self.pohId) {
        self.cpvCodeInputEntryPoint = '/opengovernmentdata/report/cpvcodes/order';
        self.cpvCodeInputObjectId = self.pohId;
    }
    else {
        self.cpvCodeInputEntryPoint = '/opengovernmentdata/report/cpvcodes/basket';
        self.cpvCodeInputObjectId = self.bksId;
    }

    dataGen.getData(self, {
        ogdId: self.ogdId,
        bksId: self.bksId,
        prsId: self.prsId,
        pohId: self.pohId,
        reportSPO: self.reportSPO
    }, "/opengovernmentdata/report/view").then(function () {
        if (self.data.deliveryDate.dateValue) {
            self.data.deliveryDate.dateValue = new Date(self.data.deliveryDate.dateValue);
        }
        else {
            self.data.deliveryDate.dateValue = null;
        }

        if (self.data.contractStartDate.minDate) {
            self.minDateNow = new Date(self.data.contractStartDate.minDate)
        }

        if (self.data.deliveryDate.minDate) {
            self.minDateNow = new Date(self.data.deliveryDate.minDate)
        }

        watchOfferNum();
    });

    var watchOfferNum = function () {
        self.scope.$watch(function () {
            if (self.data && self.data.numOffer) {
                return self.data.numOffer.value;
            }
        }, function (newVal) {
            var numSME = impactX.isDefined(self, "data.numSMEOffer.value");
            if (newVal && numSME) {
                self.scope.dialogData.numSMEOffer.$setValidity("maxValue", Number(newVal) >= Number(numSME));
            }
        });

        self.scope.$watch(function () {
            if (self.data && self.data.numSMEOffer) {
                return self.data.numSMEOffer.value;
            }
        }, function (newVal) {
            var numOffer = impactX.isDefined(self, "data.numOffer.value");
            if (newVal && numOffer) {
                self.scope.dialogData.numSMEOffer.$setValidity("maxValue", Number(numOffer) >= Number(newVal));
            }
        });
    };

    self.save = function () {
        dataGen.postAsForm(self, {formData: self.data}, '/opengovernmentdata/report/save').then(function (response) {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            self.hide(impactX.isDefined(response, 'data'));
        });
    };

    self.addAdditionalCPV = function () {
        if (!impactX.isDefined(self, 'data.additionalCPVs')) {
            self.data.additionalCPVs = [];
        }
        self.data.additionalCPVs.push({});
    };

    self.removeAdditionalCPV = function (cpv) {
        var index = self.data.additionalCPVs.indexOf(cpv);
        if (index >= 0) {
            self.data.additionalCPVs.splice(index, 1);
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        }
    };

    self.updateSubOrderType = function (subOrderTypeId) {
        if (subOrderTypeId === 0) {
            self.data.deliveryDateInDays = undefined;
        }
        else {
            self.data.deliveryDate = undefined;
        }
    };

    self.hide = function (answer) {
        $mdDialog.hide(answer);
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.toggleAdditionalInformation = function () {
        self.showAll = !self.showAll;
    };
}